export type Profession =
    "Doctor" |
    "Nurse" |
    "NurseOHA" |
    "NurseScreeningNurse" |
    "NurseMobileUnitTeam" |
    "NurseManager" |
    "Physio" |
    "Technician" |
    "MentalHealthPractitioner" |
    "MentalHealthAdvisor" |
    "Counsellor" |
    "Administrator";

const ALL_PROFESSIONS: { [name: string]: { value: Profession; displayName: string } } = {
    doctor: { value: "Doctor", displayName: "Doctor" },
    nurse: { value: "Nurse", displayName: "Nurse" },
    nurseOHA: { value: "NurseOHA", displayName: "Nurse - OHA" },
    nurseScreeningNurse: { value: "NurseScreeningNurse", displayName: "Nurse - Screening Nurse" },
    nurseMobileUnitTeam: { value: "NurseMobileUnitTeam", displayName: "Nurse - Mobile Unit Team" },
    nurseManager: { value: "NurseManager", displayName: "Nurse - Manager" },
    physio: { value: "Physio", displayName: "Physiotherapist" },
    technician: { value: "Technician", displayName: "Technician" },
    mentalHealthPractitioner: { value: "MentalHealthPractitioner", displayName: "Mental Health Practitioner" },
    mentalHealthAdvisor: { value: "MentalHealthAdvisor", displayName: "Mental Health Advisor" },
    counsellor: { value: "Counsellor", displayName: "Counsellor" },
    administrator: { value: "Administrator", displayName: "Administrator" }
};

const QA_AUDIT_PROFESSIONS: { [name: string]: { value: Profession; displayName: string } } = {
    doctor: ALL_PROFESSIONS.doctor,
    nurseOHA: ALL_PROFESSIONS.nurseOHA,
    nurseScreeningNurse: ALL_PROFESSIONS.nurseScreeningNurse,
    nurseMobileUnitTeam: ALL_PROFESSIONS.nurseMobileUnitTeam,
    nurseManager: ALL_PROFESSIONS.nurseManager,
    physio: ALL_PROFESSIONS.physio,
    mentalHealthPractitioner: ALL_PROFESSIONS.mentalHealthPractitioner,
    mentalHealthAdvisor: ALL_PROFESSIONS.mentalHealthAdvisor,
    counsellor: ALL_PROFESSIONS.counsellor,
};

const ACTIVE_PROFESSIONS: { [name: string]: { value: Profession; displayName: string } } = {
    doctor: ALL_PROFESSIONS.doctor,
    nurseOHA: ALL_PROFESSIONS.nurseOHA,
    nurseScreeningNurse: ALL_PROFESSIONS.nurseScreeningNurse,
    nurseMobileUnitTeam: ALL_PROFESSIONS.nurseMobileUnitTeam,
    nurseManager: ALL_PROFESSIONS.nurseManager,
    physio: ALL_PROFESSIONS.physio,
    technician: ALL_PROFESSIONS.technician,
    mentalHealthPractitioner: ALL_PROFESSIONS.mentalHealthPractitioner,
    mentalHealthAdvisor: ALL_PROFESSIONS.mentalHealthAdvisor,
    counsellor: ALL_PROFESSIONS.counsellor,
    administrator: ALL_PROFESSIONS.administrator,
};

export const getAdminProfessionDisplayName = (profession: Profession | undefined) => {
    const professionOptions = (Object.keys(ALL_PROFESSIONS) as (keyof typeof ALL_PROFESSIONS)[])
        .map(p => ({ text: ALL_PROFESSIONS[p].displayName, value: ALL_PROFESSIONS[p].value }));
    return professionOptions.find(o => o.value === profession)?.text ?? "";
};

export const getProfessionDropdownOptions = () => {
    return (Object.keys(ACTIVE_PROFESSIONS) as (keyof typeof ACTIVE_PROFESSIONS)[])
        .map(profession => ({ text: ACTIVE_PROFESSIONS[profession].displayName, value: ACTIVE_PROFESSIONS[profession].value }));
};

export const getQAProfessionDropdownOptions = () => {
    return (Object.keys(QA_AUDIT_PROFESSIONS) as (keyof typeof QA_AUDIT_PROFESSIONS)[])
        .map(profession => ({ text: QA_AUDIT_PROFESSIONS[profession].displayName, value: QA_AUDIT_PROFESSIONS[profession].value }));
};
